import { VigiMenuItem } from './vigi-menu-item';

export class VigiMenu {
  public id: string;
  public items: VigiMenuItem[] = [];

  constructor(id: string, items: VigiMenuItem[]) {
    this.id = id;
    this.items = items;
  }
}
